import Icon from '../components/Icon.vue'

Icon.register({
  helicopter: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M304 384c-8.8 0-20.3-5.7-25.6-12.8l-86.4-115.2-160-64-31.5-108.1c-2.5-10.1 5.1-19.9 15.5-19.9h40c5 0 9.8 2.4 12.8 6.4l43.2 57.6h208v-64h-176c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-176v64c123.7 0 224 100.3 224 224 0 17.7-14.3 32-32 32h-272zM416 195.5v124.5h124.8c-12.8-62.6-62.2-111.7-124.8-124.5zM635.4 458.8c6.6 6.6 6 17.5-1 23.7-33.1 29-53.6 29.5-68.4 29.5h-325.9c-8.8 0-16-7.2-16-16v-32.1c0-8.9 7.2-16 16-16h325.9c10.8 0 17.5-4.5 24.6-11.3 6.4-6.1 16.4-6.3 22.6 0z'
      }
    ]
  }
})
